// Utilities
import { makeStyles, tokens } from "@fluentui/react-components";
import { flexChildSizeFixed, flexChildSizeFlexible, flexParent, flexParentCenterAll, textClip } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Left Nav option style constants
 */ const rowHeight = "44px";
const linkIconWidth = "28px";
const borderRadius = "5px";
const dynamicIconBorderRadius = tokens.borderRadiusMedium;
const rowEdgeToContentSpacing = tokens.spacingHorizontalXXS;
const rowIconTextSpacing = tokens.spacingHorizontalS;
/**
 * Styles for LeftNavOption component
 */ export const useLeftNavOptionStyles = makeStyles({
    root: {
        ...flexParent(),
        ...flexChildSizeFixed(rowHeight),
        alignItems: "center",
        cursor: "pointer",
        overflow: "hidden",
        borderRadius: borderRadius,
        margin: "1px 8px 1px 8px",
        boxSizing: "content-box",
        "> a": {
            ...flexParent(),
            ...flexChildSizeFlexible("auto"),
            padding: `0px ${rowEdgeToContentSpacing}`,
            alignItems: "center",
            height: rowHeight
        },
        ":hover, :focus, :focus-within, :focus-visible": {
            backgroundColor: tokens.colorNeutralBackground1Hover,
            // Show pin button on row hover/focus
            "& [data-pin-button='true']": {
                display: "inline-flex"
            },
            "& .fui-Icon, & svg": {
                color: tokens.colorNeutralForeground2BrandHover
            }
        },
        ":active": {
            backgroundColor: tokens.colorNeutralBackground1Pressed
        }
    },
    linkContents: {
        ...flexParent("row"),
        ...flexChildSizeFlexible("auto"),
        alignItems: "center",
        minWidth: "0",
        marginBlockStart: "6px",
        marginBlockEnd: "6px",
        overflow: "visible",
        height: "22px"
    },
    linkContentsSelected: {
        position: "relative",
        borderRadius: "2px",
        "::before": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: 0,
            height: "22px",
            width: "3px",
            backgroundColor: tokens.colorNeutralForeground2BrandSelected,
            transform: "translateY(-50%)",
            borderRadius: "2px",
            boxSizing: "border-box"
        }
    },
    staticIcon: {
        ...flexParent(),
        ...flexChildSizeFixed(linkIconWidth),
        ...flexParentCenterAll,
        color: tokens.colorNeutralForeground2,
        marginInlineStart: "8px",
        fontSize: tokens.fontSizeBase600,
        "& .fui-Avatar__icon": {
            backgroundColor: "transparent !important",
            color: "inherit !important"
        }
    },
    staticIconSelected: {
        color: tokens.colorNeutralForeground2BrandSelected
    },
    staticIconHover: {
        color: tokens.colorNeutralForeground2BrandHover
    },
    dynamicIcon: {
        ...flexParent(),
        ...flexChildSizeFixed(linkIconWidth),
        ...flexParentCenterAll,
        color: tokens.colorNeutralForegroundInverted,
        marginInlineStart: "8px",
        fontSize: tokens.fontSizeBase500,
        borderRadius: dynamicIconBorderRadius
    },
    dynamicIconTextWrapper: {
        height: "28px",
        width: "28px"
    },
    text: {
        ...flexParent("column"),
        ...flexChildSizeFlexible("auto"),
        marginInlineStart: rowIconTextSpacing,
        fontStyle: "normal",
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightRegular
    },
    leftNavItem: {
        ...textClip("ellipsis"),
        color: tokens.colorNeutralForeground1
    },
    leftNavItemSelected: {
        color: tokens.colorNeutralForeground1Selected
    },
    leftNavItemHover: {
        color: tokens.colorNeutralForeground1Hover
    },
    pinButton: {
        display: "none",
        backgroundColor: "transparent",
        color: tokens.colorNeutralForeground1Hover,
        border: "none",
        ":hover": {
            backgroundColor: "transparent"
        },
        ":focus": {
            backgroundColor: "transparent"
        },
        ":focus-within": {
            backgroundColor: "transparent"
        },
        ":focus-visible": {
            backgroundColor: "transparent"
        }
    },
    simpleBreadcrumb: {
        display: "flex",
        alignItems: "center",
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground2
    },
    breadcrumbItem: {
        color: tokens.colorNeutralForeground2
    },
    breadcrumbItemSelected: {
        color: tokens.colorNeutralForeground1Selected
    },
    breadcrumbItemHover: {
        color: tokens.colorNeutralForeground1Hover
    },
    chevron: {
        color: tokens.colorNeutralForeground2,
        margin: "0 4px"
    },
    chevronSelected: {
        color: tokens.colorNeutralForeground1Selected
    },
    chevronHover: {
        color: tokens.colorNeutralForeground1Hover
    },
    selected: {
        backgroundColor: tokens.colorNeutralBackground1Selected,
        "& .fui-Icon, & svg": {
            color: tokens.colorNeutralForeground2BrandSelected
        }
    },
    hoveredNotSelected: {
        backgroundColor: tokens.colorNeutralBackground1Hover
    }
});
